import type { UploadPhase, UploadTask } from '../types/uploads';

/** Phases that continue without user interaction and therefore need an app-wide activity signal. */
const BACKGROUND_TRANSFER_PHASES: ReadonlySet<UploadPhase> = new Set([
  'queued',
  'reattaching',
  'hashing',
  'prechecking',
  'creating',
  'uploading',
  'transferring',
  'completing',
  'processing',
]);

export function activeTransferCount(items: readonly UploadTask[]): number {
  return items.reduce(
    (count, item) => count + (BACKGROUND_TRANSFER_PHASES.has(item.phase) ? 1 : 0),
    0,
  );
}
